import React from 'react';
import { Card, CardContent } from '../../../ui/card';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from '../../../ui/table';
import { TableBlock as TableBlockType } from '../../../../types/report-builder';

interface Props {
  block: TableBlockType;
}

const TableBlock: React.FC<Props> = ({ block }) => {
  const columns = Array.isArray(block.columns) ? block.columns : [];
  const rows = Array.isArray(block.rows) ? block.rows : [];

  return (
    <Card className="my-6 overflow-hidden border-border/70 bg-card shadow-[var(--shadow-card)]">
      <CardContent className="py-5">
        {block.title && (
          <h3 className="mb-3 text-sm font-semibold text-foreground">{block.title}</h3>
        )}
        <div className="overflow-hidden rounded-2xl border border-border/70">
          <Table>
            <TableHeader>
              <TableRow>
                {columns.map((col, i) => (
                  <TableHead key={i}>{col}</TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((row, rowIdx) => (
                <TableRow key={rowIdx}>
                  {(Array.isArray(row) ? row : []).map((cell, cellIdx) => (
                    <TableCell key={cellIdx}>{String(cell ?? '')}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
};

export default TableBlock;
